export const NAO_APLICAVEL = 0;

export const AGUARDANDO_APROVACAO_PARA_EMISSAO = 1;

export const AGUARDANDO_CONFIRMACAO_DE_NAO_EMISSAO = 2;

export const EMISSAO_COBRANCA_APROVADA = 3;

export const EMISSAO_COBRANCA_RECUSADA = 4;

export const ChargeStatusTypes = {
  NAO_APLICAVEL: NAO_APLICAVEL,
  AGUARDANDO_APROVACAO_PARA_EMISSAO: AGUARDANDO_APROVACAO_PARA_EMISSAO,
  AGUARDANDO_CONFIRMACAO_DE_NAO_EMISSAO: AGUARDANDO_CONFIRMACAO_DE_NAO_EMISSAO,
  EMISSAO_COBRANCA_APROVADA: EMISSAO_COBRANCA_APROVADA,
  EMISSAO_COBRANCA_RECUSADA: EMISSAO_COBRANCA_RECUSADA,
};

export const ChargeStatus: Record<number, string> = {
  [NAO_APLICAVEL]: "Não se aplica",
  [AGUARDANDO_APROVACAO_PARA_EMISSAO]: "Aguardando aprovação para emissão",
  [AGUARDANDO_CONFIRMACAO_DE_NAO_EMISSAO]: "Aguardando confirmação de não emissão",
  [EMISSAO_COBRANCA_APROVADA]: "Emissão de cobrança aprovada",
  [EMISSAO_COBRANCA_RECUSADA]: "Emissão de cobrança recusada",
};
